<template>
  <div class="my-canter">
    <ul class="my-menu">
        <li v-for="(item,index) in menu" :key="index" @click="menuIdx = index" :class="{'active':menuIdx == index}">
            <i :class="item.icon"></i>
            {{item.name}}
        </li>
        <li @click="back"><i class="el-icon-s-unfold"></i>退出</li>
    </ul>
    <div class="my-info">
        <div class="setUp" v-show="menuIdx == 0">
            <div class="title">个人设置</div>
            <mySetup></mySetup>
        </div>
        <div class="setUp" v-show="menuIdx == 1">
            <div class="title">我的收藏</div>
            <myCollection></myCollection>
        </div>
        <div class="setUp" v-show="menuIdx == 2">
            <div class="title">我的纠错</div>
            <myCorrection></myCorrection>
        </div>
        <div class="setUp" v-show="menuIdx == 3">
            <div class="title">我的添加</div>
            <myAdd></myAdd>
        </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import myAdd from './components/my-add.vue'
import myCollection from './components/my-collection.vue'
import myCorrection from './components/my-correction.vue'
import mySetup from './components/my-setup.vue'
import { mapActions } from 'vuex'
export default {
  name: 'login',
  components:{myAdd,myCollection,myCorrection,mySetup},
  data () {
    return {
      menu:[
        { name:'个人设置',icon:'el-icon-s-tools' },
        { name:'我的收藏',icon:'el-icon-s-goods' },
        { name:'我的纠错',icon:'el-icon-error' },
        { name:'我的添加',icon:'el-icon-circle-plus' }
      ],
      menuIdx:0
    }
  },
  created() {
    
  },
  mounted () {
    console.log(this.$route)
    this.menuIdx = this.$route.query.menuIdx
  },
  computed: {

  },
  methods: {
    ...mapActions(['Logout']),
    back(){
      this.Logout().then(res => {
        Vue.ls.remove(ACCESS_TOKEN)
        window.location.reload()
        // window.history.pushState(null, '', '/login')
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.active{
    background: #4677EE;
    color: #fff;
    border-radius: 10px;
}
.my-canter{
    width: 100%;
    height: 100%;
    display: flex;
    .my-menu{
        width: 260px;
        padding: 10px 20px;
        border-right: 1px solid #F7F8FA;
        li{
            list-style: none;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: bold;
            padding:12px 9px;
            i{
                margin-right: 8px;
            }
        }
    }
    .my-info{
        padding:20px;
        background: #F7F8FA;
        flex: 1;
        .title{
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            margin-bottom: 20px;
        }
    }
}
</style>
